import "../Styles/callback.css";

window.onload = function () {
    const el = document.getElementById("js-callback-page");

    if (el) {
        const callbackUrl = el.getAttribute("data-callback-url");

        window.location.href = callbackUrl;
    }
}

setTimeout(() => {
    const el = document.getElementById("js-callback-not-working");
    if (el) {
        el.classList.remove("hidden");
    }
}, 5000);